export const SELECTION_STYLE_PROPERTIES = [
  'fontSize',
  'fontFamily',
  'color',
  'isBold',
  'isItalic',
  'isUnderline',
  'textCase',
  'styleId'
];

export const PROPERTIES_SELECTION_FABRICS = {
  FONT_SIZE: 'fontSize',
  FONT_FAMILY: 'fontFamily',
  COLOR: 'fill',
  IS_BOLD: 'fontWeight',
  IS_ITALIC: 'fontStyle',
  IS_UNDERLINE: 'underline',
  TEXT_CASE: 'textCase',
  STYLEID: 'styleId'
};

export const TWO_EM_DASH = '⸺';
